import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NavbarMex from '../components/navbarMex';
import sampleFile from './envio_masivo_plantilla.xlsx';
import { LoadingOutlined, InfoCircleOutlined, WarningOutlined, CheckCircleOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { Table, Button, Upload, Select, Spin, Form, message, Alert, Modal, Checkbox, Tooltip } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import './ExcelUploader.css';
import { PDFDocument } from 'pdf-lib';
import axios from 'axios';
import ManifiestoGenerator from '../envioCompleto/manifestoGenerator'; // Importando el componente ManifiestoGenerator

const { Option } = Select;

const ExcelUploader = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cotizacionResults, setCotizacionResults] = useState({});
  const [selectedTransportadora, setSelectedTransportadora] = useState('');
  const [selectedTipoEnvio, setSelectedTipoEnvio] = useState('');
  const [sucursalId, setSucursalId] = useState('');
  const [allCotizacionesDone, setAllCotizacionesDone] = useState(false);
  const [showTipoEnvioSelect, setShowTipoEnvioSelect] = useState(false);
  const [saldoDisponible, setSaldoDisponible] = useState('');
  const [loadingSaldo, setLoadingSaldo] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false); // Estado de carga para el PDF
  const [saldoNumerico, setSaldoNumerico] = useState(0); // Nuevo estado para el saldo numérico
  const [statusWhatsapp, setStatusWhatsapp] = useState(false); // Add this state
  const [selectedTamanoGuia, setSelectedTamanoGuia] = useState('2'); // Nuevo estado para tamaño de guía
  const [modalMessage, setModalMessage] = useState(null); // Añadir estado para mensajes modales
  const [seguro99Enabled, setSeguro99Enabled] = useState(true); // Add this state
  const [seguro99PlusEnabled, setSeguro99PlusEnabled] = useState(false);
  // Nuevos estados para tracking del progreso
  const [preenvioStatus, setPreenvioStatus] = useState({}); // Status por cada documento
  const [pdfGenerationStatus, setPdfGenerationStatus] = useState({}); // Status generación de PDFs
  // Nuevo estado para controlar el botón de sumar costo de envío
  const [costoEnvioSumado, setCostoEnvioSumado] = useState(false);
  const [recotizando, setRecotizando] = useState(false);
  const [blockCheckInput, setBlockCheckInput] = useState(false);
  //const [seguroPayMessage, setSeguroPayMessage] = useState(false);
  const [isVisibleModalWarning, setIsVisibleModalWarning] = useState(false);
  const [desactivateSeguroPlus, setDesactivateSeguroPlus] = useState(false);

  const fetchModalMessage = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/modals');
      if (response.data && response.data.activo) {
        setModalMessage(response.data);
      }
    } catch (error) {
      console.error('Error al obtener el mensaje del modal', error);
    }
  };

  useEffect(() => {
    fetchModalMessage();
  }, []);

  const transportadoras = ["interrapidisimo", "tcc", "servientrega", "coordinadora"];
  const tipoEnvio = ["envio puerta a puerta", "entrega en oficina"];


  const fetchSaldoDisponible = async () => {
    setLoadingSaldo(true);
    const user_id = localStorage.getItem('usuario_id');
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`https://99envios.app/api/online/consultar-saldo/${user_id}`, {
        method: 'GET',
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      setSaldoNumerico(data.saldo_disponible); // Guardamos el valor numérico
      setSaldoDisponible(data.saldo_disponible.toLocaleString()); // Guardamos el valor formateado para mostrar
    } catch (error) {
      console.error('Error al consultar saldo:', error);
      setSaldoDisponible('Error al cargar');
      setSaldoNumerico(0);
    } finally {
      setLoadingSaldo(false);
    }
  };

  useEffect(() => {
    fetchSaldoDisponible();
  }, []);



  const handleFileUpload = ({ file }) => {
    setLoadingPdf(true);
    const reader = new FileReader();


    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Filtrar filas vacías o inválidas
      const filteredData = jsonData.filter(row => {
        // Verificar si la fila tiene al menos algunos campos obligatorios
        const hasRequiredFields =
          row['numero documento'] || // ID del destinatario
          row['nombre'] || // Nombre del destinatario
          row['codigo destino'] || // Código de ciudad
          row['direccion']; // Dirección

        // Si tiene al menos uno de los campos requeridos, verificamos que no sea una fila completamente vacía
        if (hasRequiredFields) {
          // Verificar si hay al menos un campo con valor no vacío
          return Object.values(row).some(value =>
            value !== undefined &&
            value !== null &&
            value.toString().trim() !== ''
          );
        }
        return false;
      });

      // Limpiar los datos y asegurarse de que los campos numéricos sean números
      const cleanedData = filteredData.map(row => {
        const contrapagoValue = row['AplicaContrapago'];
        let aplicaContrapago = false;

        // Convertir diferentes formatos de "verdadero" a true
        if (typeof contrapagoValue === 'string') {
          const normalizedValue = contrapagoValue.toLowerCase().trim();
          aplicaContrapago = normalizedValue === 'verdadero' ||
            normalizedValue === 'true' ||
            normalizedValue === 'si' ||
            normalizedValue === 'sí' ||
            normalizedValue === '1';
        } else if (typeof contrapagoValue === 'boolean') {
          aplicaContrapago = contrapagoValue;
        } else if (typeof contrapagoValue === 'number') {
          aplicaContrapago = contrapagoValue === 1;
        }

        return {
          ...row,
          'Peso': parseFloat(row['Peso']) || 0,
          'valor declarado': parseFloat(row['valor declarado']) || 50000,
          'AplicaContrapago': aplicaContrapago,
          'seguro99': seguro99Enabled, // Add seguro99 to each row
          'numero documento': row['numero documento']?.toString().trim(),
          'nombre': row['nombre']?.toString().trim(),
          'direccion': row['direccion']?.toString().trim(),
          'codigo destino': row['codigo destino']?.toString().trim(),
          'dice contener': row['dice contener']?.toString().trim(),
          'primer apellido': row['primer apellido']?.toString().trim(),
          'segundo apellido': row['segundo apellido']?.toString().trim(),
          'Observaciones': row['Observaciones']?.toString().trim()
        };
      });

      setData(cleanedData);
      setAllCotizacionesDone(false);
      setLoadingPdf(false);
    };

    reader.readAsBinaryString(file);
  };

  useEffect(() => {
    if (id) {
      localStorage.setItem('id', id);
    }
  }, [id]);

  useEffect(() => {
    const fetchSucursalId = async () => {
      try {
        const response = await fetch(`https://99envios.app/api/online/sucursal-codigo-sucursal/${id}`);
        if (!response.ok) {
          throw new Error('Error fetching sucursal ID');
        }
        const data = await response.json();
        console.log('Sucursal ID:', data);
        setSucursalId(data); // Actualiza el estado con el ID de la sucursal
      } catch (error) {
        console.error('Error fetching sucursal ID:', error);
        return null;
      }
    };

    fetchSucursalId();
  }, [id]);

  // Add this useEffect to fetch WhatsApp status
  useEffect(() => {
    const fetchSucursalData = async () => {
      try {
        const sucursalResponse = await axios.get(`https://99envios.app/api/online/sucursal/${id}`);
        setStatusWhatsapp(sucursalResponse.data.status_whatsapp === 1);
        const porcentajeEstado5 = sucursalResponse.data.porcentaje_estado_5;
        if (porcentajeEstado5 >= 0.4) {
        
        // Desactivar el seguro en checkbox
        setSeguro99Enabled(false);
        //Block the checkbox
        setBlockCheckInput(true);
        setDesactivateSeguroPlus(true);

       /* } else if(porcentajeEstado5 >= 0.2 && porcentajeEstado5 < 0.39 ) {
        setSeguroPayMessage(true)   */
        } else if (porcentajeEstado5 >= 0.35) {
          setDesactivateSeguroPlus(true);
      } else {

      }
        console.log('Status WhatsApp:', sucursalResponse.data.status_whatsapp);
      } catch (error) {
        console.error('Error fetching sucursal data:', error);
      }
    };

    if (id) {
      fetchSucursalData();
    }
  }, [id]);

  // Función de ayuda para depuración que muestra cada valor diferente
  const logUniqueValues = (results) => {
    if (Object.keys(results).length > 0) {
      console.log('ID -> Valor de cotización:');
      Object.entries(results).forEach(([key, val]) => {
        if (val.exito) {
          console.log(`${key} -> ${val.valor}`);
        }
      });
    }
  };
  
  // Modificación a handleCotizar para garantizar resultados únicos
  const handleCotizar = async () => {
    setLoading(true);
    setCotizacionResults({}); // Limpiar resultados anteriores
    let failedCotizaciones = [];
    let localResults = {}; // Variable local para mantener TODOS los resultados

    // Procesamos cada registro individualmente
    for (let i = 0; i < data.length; i++) {
        const formData = data[i];

        if (!formData['numero documento']) {
            message.error(`El campo "numero documento" es obligatorio para destinatario ${formData.nombre || 'sin nombre'}`);
            continue;
        }

        const diceContenerValue = formData['dice contener'] ? formData['dice contener'].toString() : '';
        if (!diceContenerValue) {
            message.error(`El campo "Dice Contener" es obligatorio para documento ${formData['numero documento']}`);
            continue;
        }

        // Crear un ID único combinando el índice con el documento
        const uniqueId = `${i}_${formData['numero documento'].toString()}`;
        console.log(`[${i+1}/${data.length}] Procesando cotización para fila ${i} con documento ${formData['numero documento']}... ID único: ${uniqueId}`);

        try {
            const current = new Date();
            const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                current.getFullYear();

            const cotizacionData = {
                destino: {
                    nombre: "",
                    codigo: formData['codigo destino'],
                },
                origen: {
                    nombre: "",
                    codigo: "",
                },
                IdTipoEntrega: selectedTransportadora === 'interrapidisimo' ? 
                    (selectedTipoEnvio === 'envio puerta a puerta' ? 1 : 2) : 1,
                IdServicio: 1,
                peso: parseFloat(formData.Peso) || 0,
                largo: 1,
                ancho: 1,
                alto: 1,
                fecha: formattedDate,
                AplicaContrapago: formData.AplicaContrapago || false,
                valorDeclarado: parseInt(formData['valor declarado'], 10) || 50000,
                transportadora: {
                    pais: "colombia",
                    nombre: selectedTransportadora,
                },
                origenCreacion: 1,
                seguro99: seguro99Enabled,
                seguro99plus: seguro99PlusEnabled,

            };

            console.log(`Enviando solicitud para ${uniqueId}:`, cotizacionData);

            const response = await fetch(`https://integration.99envios.app/api/sucursal/cotizar_individual/${sucursalId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cotizacionData),
            });

            if (!response.ok) {
                throw new Error(`Error en la cotización del documento ${formData['numero documento']}: ${response.status} ${response.statusText}`);
            }

            const cotizacionResult = await response.json();
            console.log(`Respuesta recibida para ${uniqueId}:`, cotizacionResult);

            // Guardar con ID único en variable local
            localResults[uniqueId] = {
                mensaje: cotizacionResult.mensaje,
                valor: parseFloat(cotizacionResult.valor) || 0,
                valor_contrapago: parseFloat(cotizacionResult.valor_contrapago) || 0,
                comision_interna: parseFloat(cotizacionResult.comision_interna) || 0,
                sobreflete: parseFloat(cotizacionResult.sobreflete) || 0,
                dias: cotizacionResult.dias,
                IdServicio: cotizacionResult.IdServicio,
                fecha_entrega: cotizacionResult.fecha_entrega,
                porcentaje_seguro_99: parseFloat(cotizacionResult.porcentaje_seguro_99) || 0,
                seguro99: parseFloat(cotizacionResult.seguro99) || 0,
                exito: true,
                documento: formData['numero documento'].toString(),
                rowIndex: i,
                _id: uniqueId
            };

        } catch (error) {
            console.error(`Error al cotizar fila ${i} con documento ${formData['numero documento']}:`, error);

            // Guardar error con ID único en variable local
            localResults[uniqueId] = {
                exito: false,
                mensaje: error.message || 'Error desconocido en la cotización',
                documento: formData['numero documento'].toString(),
                rowIndex: i,
                _id: uniqueId
            };

            failedCotizaciones.push(`Fila ${i+1} (${formData['numero documento']})`);
        }

        await new Promise(resolve => setTimeout(resolve, 300));
    }

    // SOLO AL FINAL: Actualizar el estado UNA SOLA VEZ con todos los resultados
    console.log('Resultados finales a guardar:', localResults);
    setCotizacionResults(localResults);

    setLoading(false);

    // Usar la variable local para contar los resultados exitosos
    const successCount = Object.values(localResults).filter(result => result && result.exito === true).length;
    setAllCotizacionesDone(successCount > 0 && failedCotizaciones.length === 0);

    if (failedCotizaciones.length > 0) {
        message.error(`Error en la cotización de: ${failedCotizaciones.join(', ')}`);
    } else if (successCount > 0) {
        message.success(`Se cotizaron exitosamente ${successCount} envíos`);
    }
    
    // Devolvemos el resultado para que se pueda usar en handleSumarCostoEnvio
    return { success: successCount > 0, localResults };
  };

  const handleTransportadoraChange = (value) => {
    setSelectedTransportadora(value);
    setShowTipoEnvioSelect(value === 'interrapidisimo');
    if (value === 'interrapidisimo') {
      setSelectedTipoEnvio('');
    } else {
      setSelectedTipoEnvio('envio puerta a puerta');
    }
    setSeguro99Enabled(seguro99Enabled); // Aseguramos que seguro99 no se modifique
  };

  const handleTipoEnvioChange = (value) => {
    setSelectedTipoEnvio(value);
  };

  const requestPdf = async (pdfData, retries = 3) => {
    let attempt = 0;
    while (attempt < retries) {
      try {
        attempt++;
        const pdfResponse = await fetch(
          `https://integration.99envios.app/api/sucursal/pdf/${sucursalId}/${selectedTamanoGuia}`, // URL modificada
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(pdfData),
          }
        );

        if (!pdfResponse.ok) {
          const pdfErrorData = await pdfResponse.json();
          const pdfErrorMessage = pdfErrorData.mensaje_completo
            ? pdfErrorData.mensaje_completo.join(' ')
            : pdfErrorData.mensaje;
          throw new Error(`Error al generar PDF: ${pdfErrorMessage}`);
        }

        // Maneja la URL directa del PDF
        const pdfUrl = await pdfResponse.text(); // La API responde con una URL directa
        if (!pdfUrl) throw new Error('No se recibió la URL del PDF');
        return pdfUrl; // Devuelve la URL
      } catch (error) {
        console.error(`Intento ${attempt} fallido para generar el PDF`, error);
        if (attempt >= retries) throw new Error('Error persistente en la generación del PDF');
      }
    }
  };

  const handlePreenvio = async (formDataGuia, index) => {
    // Crear el mismo ID único que usamos en handleCotizar
    const uniqueId = `${index}_${formDataGuia['numero documento']?.toString()}`;
    const cotizacion = cotizacionResults[uniqueId];
    
    if (!cotizacion) {
      message.error(`No se ha cotizado el envío para el destinatario con documento ${formDataGuia['numero documento']} en la fila ${index + 1}`);
      return null;
    }

    const pesoFinal = formDataGuia.Peso;
    const valorDeclaradoLimpio = parseFloat(formDataGuia['valor declarado']) || 50000;
    const formattedDate = "28-06-2024";

    const diceContenerValue = formDataGuia['dice contener'] ? formDataGuia['dice contener'].toString() : '';

    if (!diceContenerValue) {
      message.error(`El campo "Dice Contener" es obligatorio para el destinatario con documento ${formDataGuia['numero documento']}`);
      return null;
    }

    const guiaData = {
      IdTipoEntrega: selectedTipoEnvio === 'envio puerta a puerta' ? 1 : 2,
      IdServicio: 1,
      AplicaContrapago: formDataGuia.AplicaContrapago || false,
      peso: pesoFinal,
      largo: parseFloat(formDataGuia.Largo) || 1,
      ancho: parseFloat(formDataGuia.Ancho) || 1,
      alto: parseFloat(formDataGuia.Alto) || 1,
      diceContener: diceContenerValue,
      valorDeclarado: valorDeclaradoLimpio,
      fecha: formattedDate,
      seguro99: seguro99Enabled, // Aseguramos que seguro99 esté incluido
      seguro99plus: seguro99PlusEnabled,
      Destinatario: {
        tipoDocumento: formDataGuia.tipoDocumento ? formDataGuia.tipoDocumento.toString() : "CC",
        numeroDocumento: formDataGuia['numero documento'] ? formDataGuia['numero documento'].toString() : `ID-${index}`,
        nombre: formDataGuia.nombre ? formDataGuia.nombre.toString() : "",
        primerApellido: formDataGuia['primer apellido'] ? formDataGuia['primer apellido'].toString() : "",
        segundoApellido: formDataGuia['segundo apellido'] ? formDataGuia['segundo apellido'].toString() : "",
        telefono: formDataGuia.telefono ? formDataGuia.telefono.toString() : "",
        direccion: formDataGuia.direccion ? formDataGuia.direccion.toString() : "",
        correo: formDataGuia.correo ? formDataGuia.correo.toString() : "",
        idLocalidad: formDataGuia['codigo destino'] ? formDataGuia['codigo destino'].toString() : "",
      },
      Observaciones: formDataGuia.Observaciones ? formDataGuia.Observaciones.toString() : "",
      transportadora: {
        pais: "colombia",
        nombre: selectedTransportadora,
        aplicaContrapago: formDataGuia.AplicaContrapago,
      },
      origenCreacion: 1,
    };

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://integration.99envios.app/api/sucursal/preenvio/${sucursalId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(guiaData),
      });        if (!response.ok) {
          const errorData = await response.json();
          throw {
            message: errorData.respuesta || errorData.mensaje || 'Error en el preenvío',
            details: errorData.details || errorData.mensaje_completo?.join(' ') || 'Error en el servicio',
            rawError: errorData // Guardamos el error completo para debugging
          };
      }

      const responseData = await response.json();
      const numeroPreenvio = responseData.numeroPreenvio.toString();

      const pdfData = {
        transportadora: {
          pais: "colombia",
          nombre: selectedTransportadora,
        },
        guia: numeroPreenvio,
        AplicaContrapago: formDataGuia.AplicaContrapago,
        origenCreacion: 1,
      };

      // Llamada a requestPdf
      const pdfUrl = await requestPdf(pdfData);
      return {
        numeroPreenvio: numeroPreenvio, // Cambiado de numeroDocumento a numeroPreenvio
        pdfUrl
      };
    } catch (error) {
      console.error('Error:', error);
      throw error; // Propagar el error en lugar de retornar null
    }
  };



  const handlePreenvioAndZip = async () => {
    setLoading(true);

    // Reset status states
    setPreenvioStatus({});
    setPdfGenerationStatus({});

    // Calcular el total de las guías sin contrapago
    const totalGuiasSinContrapago = data.reduce((acc, item) => {
      if (!item.AplicaContrapago) {
        const cotizacion = cotizacionResults[item['numero documento']];
        if (cotizacion && cotizacion.exito) {
          const valorTotal = (cotizacion.valor || 0) + (cotizacion.comision_interna || 0) + (cotizacion.sobreflete || 0);
          return acc + valorTotal;
        }
      }
      return acc;
    }, 0);

    // Verificar si el saldo disponible es suficiente solo si hay guías sin contrapago
    if (totalGuiasSinContrapago > 0 && totalGuiasSinContrapago > saldoNumerico) {
      message.error(`Saldo insuficiente. Necesitas $${totalGuiasSinContrapago.toLocaleString()} pero solo tienes $${saldoDisponible}`);
      setLoading(false);
      return;
    }

    let failedDocuments = [];
    let allPdfUrls = []; // Array para guardar todas las URLs de PDFs

    const reintentarPreenvio = async (row, index, retries = 3) => {
      let attempt = 0;
      let result = null;
      const docId = row['numero documento'];

      // Actualizar estado a "procesando preenvío"
      setPreenvioStatus(prev => ({ ...prev, [docId]: 'processing' }));

      let lastError = null;
      while (attempt < retries) {
        attempt++;
        try {
          result = await handlePreenvio(row, index);
          if (result && result.pdfUrl) {
            // Marcar preenvío como exitoso y comenzar generación de PDF
            setPreenvioStatus(prev => ({ ...prev, [docId]: 'success' }));
            setPdfGenerationStatus(prev => ({ ...prev, [docId]: 'processing' }));
            return result;
          }
        } catch (error) {
          console.error(`Intento ${attempt} fallido para documento ${docId}:`, error);
          lastError = error;
        }
      }

      // Marcar preenvío como fallido con el mensaje de error
      setPreenvioStatus(prev => ({ 
        ...prev, 
        [docId]: { 
          status: 'error',
          message: lastError?.message || 'Error en el preenvío',
          details: lastError?.details || lastError?.message || 'Error desconocido en el preenvío'
        } 
      }));
      failedDocuments.push(docId || `ID-${index}`);
      return null;
    };

    try {
      // Procesar preenvíos uno por uno para mejor visualización del progreso
      for (const [index, row] of data.entries()) {
        const result = await reintentarPreenvio(row, index);
        if (result && result.pdfUrl) {
          allPdfUrls.push(result.pdfUrl);

          // Marcar generación de PDF como exitosa
          setPdfGenerationStatus(prev => ({ ...prev, [row['numero documento']]: 'success' }));

          // Enviar notificación de WhatsApp para cada guía generada exitosamente
          if (statusWhatsapp) {
            try {
              await axios.post(`https://99envios.app/api/online/whatsapp/message_template_envios/${result.numeroPreenvio}`, {
                tamano_guia: selectedTamanoGuia
              });
            } catch (whatsAppError) {
              console.error('Error enviando WhatsApp para guía:', result.numeroPreenvio, whatsAppError);
            }
          }
        } else {
          // Marcar generación de PDF como fallida
          setPdfGenerationStatus(prev => ({ ...prev, [row['numero documento']]: 'error' }));
        }
      }

      // Si hay URLs de PDFs exitosos, combinarlos en un solo PDF
      if (allPdfUrls.length > 0) {
        const mergedPdf = await PDFDocument.create();

        // Descargar y combinar todos los PDFs
        for (const url of allPdfUrls) {
          try {
            const pdfBytes = await fetch(url).then(res => res.arrayBuffer());
            const pdf = await PDFDocument.load(pdfBytes);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            pages.forEach(page => mergedPdf.addPage(page));
          } catch (error) {
            console.error('Error al procesar PDF:', url, error);
          }
        }

        // Guardar y mostrar el PDF combinado
        const mergedPdfBytes = await mergedPdf.save();
        const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
        const mergedPdfUrl = URL.createObjectURL(mergedPdfBlob);
        window.open(mergedPdfUrl, '_blank');
        message.success(`Se generaron y combinaron ${allPdfUrls.length} guías exitosamente.`);
      }

      if (failedDocuments.length > 0) {
        message.error(`No se pudieron generar los PDFs para los siguientes documentos: ${failedDocuments.join(', ')}`);
      }
    } catch (error) {
      console.error('Error al generar los PDFs:', error);
      message.error('Hubo un error al generar los PDFs');
    } finally {
      setLoading(false);
    }
  };

  const handleSeguro99Change = (e,checked) => {
    const { name } = e.target;

    if(name === "seguro99Plus") {
      if(checked && desactivateSeguroPlus) {
        setSeguro99PlusEnabled(false);
        return;
      }

      if(!checked) {
        setSeguro99PlusEnabled(false);
        return;
      }
      if(checked && seguro99Enabled) {
        setSeguro99Enabled(false);
        return;
      }
      if(checked && !seguro99Enabled) {
        setSeguro99PlusEnabled(true);
        return;
      }
    }

    if(name === "seguro99") {
      if (checked && blockCheckInput) {
        setIsVisibleModalWarning(true);
        return;
      }

      if(checked && seguro99PlusEnabled) {
        setSeguro99PlusEnabled(false);
        return;
      }
      if (!checked) {
        Modal.warning({
          title: (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#d48806',
              fontSize: '16px',
              fontWeight: '500',
              marginBottom: '16px'
            }}>
              <WarningOutlined />
              ¿Estás seguro?
            </div>
          ),
          content: (
            <div style={{
              padding: '20px',
              background: '#fffbe6',
              borderRadius: '8px',
              border: '1px solid #ffe58f'
            }}>
              <p style={{
                color: '#666',
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Al desactivar esta opción, deberás asumir el costo del envío de ida en caso de que el pedido sea devuelto.
              </p>
            </div>
          ),
          okText: 'Entendido',
          okButtonProps: {
            style: {
              backgroundColor: '#d48806',
              borderColor: '#d48806',
              borderRadius: '6px',
              height: '36px',
              fontWeight: '500',
              boxShadow: '0 2px 0 rgba(0,0,0,0.043)'
            }
          },
          onOk() {
            setSeguro99Enabled(false);
          },
          maskClosable: true,
          centered: true,
          width: 480,
          className: 'seguro99-warning-modal'
        });
      } else {
        setSeguro99Enabled(true);
      }
    }
    
  };

  // Añadir función para quitar el costo de envío
  const handleToggleCostoEnvio = async () => {
    if (recotizando) return;
    
    setRecotizando(true);
    
    // Si ya está sumado, quitamos el costo. Si no, lo sumamos
    if (costoEnvioSumado) {
      message.loading('Recalculando cotizaciones sin costo de envío incluido...', 0);
      
      // Crear copia del array de datos para modificarlo
      const dataOriginal = [...data];
      
      // Para cada fila, revertimos al valor declarado original (aproximadamente)
      dataOriginal.forEach((row, index) => {
        const uniqueId = `${index}_${row['numero documento']?.toString()}`;
        const cotizacion = cotizacionResults[uniqueId];
        
        if (cotizacion && cotizacion.exito) {
          // Calcular el costo total del envío
          const valorTotal = (cotizacion.valor || 0) + 
                            (cotizacion.sobreflete || 0) + 
                            (cotizacion.valor_contrapago || 0) + 
                            (cotizacion.comision_interna || 0) + 
                            (cotizacion.seguro99 || 0);
          
          // Sumar un 9% adicional al costo del envío
          const adjustedTotal = valorTotal + (valorTotal * 0.090);
          
          // Obtenemos el valor declarado actual
          const valorDeclaradoActual = parseFloat(row['valor declarado']) || 50000;
          
          // Calculamos el valor declarado original restando el ajuste
          const valorDeclaradoOriginal = valorDeclaradoActual - adjustedTotal;
          
          // Actualizamos al valor original (nunca menos de 50000)
          dataOriginal[index]['valor declarado'] = Math.max(valorDeclaradoOriginal, 50000);
        }
      });
      
      // Actualizar el estado con los datos originales
      setData(dataOriginal);
      
      // Realizar una nueva cotización con los valores actualizados
      try {
        setCotizacionResults({});
        await handleCotizar();
        setCostoEnvioSumado(false);
        message.success('Se ha quitado el costo de envío del valor declarado y recotizado exitosamente');
      } catch (error) {
        console.error('Error al recotizar sin costo de envío:', error);
        message.error('Ocurrió un error al recotizar sin costo de envío');
      } finally {
        setRecotizando(false);
        message.destroy();
      }
    } else {
      // Ejecutar el comportamiento original de sumar el costo
      message.loading('Recalculando cotizaciones con costo de envío incluido...', 0);
      
      // Crear copia del array de datos para modificarlo
      const updatedData = [...data];
      
      // Para cada fila, actualizar el valor declarado sumando el costo del envío
      updatedData.forEach((row, index) => {
        const uniqueId = `${index}_${row['numero documento']?.toString()}`;
        const cotizacion = cotizacionResults[uniqueId];
        
        if (cotizacion && cotizacion.exito) {
          // Calcular el costo total del envío
          const valorTotal = (cotizacion.valor || 0) + 
                             (cotizacion.sobreflete || 0) + 
                             (cotizacion.valor_contrapago || 0) + 
                             (cotizacion.comision_interna || 0) + 
                             (cotizacion.seguro99 || 0);
          
          // Sumar un 9% adicional al costo del envío
          const adjustedTotal = valorTotal + (valorTotal * 0.090);
          
          // Obtener el valor declarado actual y sumarle el costo ajustado
          const valorDeclaradoActual = parseFloat(row['valor declarado']) || 50000;
          const nuevoValorDeclarado = valorDeclaradoActual + adjustedTotal;
          
          // Actualizar el valor declarado en la fila
          updatedData[index]['valor declarado'] = nuevoValorDeclarado;
        }
      });
      
      // Actualizar el estado con los nuevos datos
      setData(updatedData);
      
      // Realizar una nueva cotización con los valores actualizados
      try {
        setCotizacionResults({});
        await handleCotizar();
        setCostoEnvioSumado(true);
        message.success('Se ha sumado el costo de envío al valor declarado y recotizado exitosamente');
      } catch (error) {
        console.error('Error al recotizar con costo de envío sumado:', error);
        message.error('Ocurrió un error al recotizar con costo de envío sumado');
      } finally {
        setRecotizando(false);
        message.destroy();
      }
    }
  };

  const columns = [
    { title: 'PRIMER APELLIDO', dataIndex: 'primer apellido', key: 'primer apellido', width: 120 },
    { title: 'SEGUNDO APELLIDO', dataIndex: 'segundo apellido', key: 'segundo apellido', width: 120 },
    { title: 'NOMBRE DESTINATARIO', dataIndex: 'nombre', key: 'nombre', width: 120 },
    { title: 'IDENTIFICACION DESTINATARIO', dataIndex: 'numero documento', key: 'numero documento', width: 150 },
    { title: 'DIRECCIÓN DESTINATARIO', dataIndex: 'direccion', key: 'direccion', width: 200 },
    { title: 'CODIGO CIUDAD DESTINATARIO', dataIndex: 'codigo destino', key: 'codigo destino', width: 150 },
    { title: 'DICE CONTENER', dataIndex: 'dice contener', key: 'dice contener', width: 120 },
    { title: 'OBSERVACIONES', dataIndex: 'Observaciones', key: 'Observaciones', width: 150 },
    { title: 'PESO', dataIndex: 'Peso', key: 'Peso', width: 100 },
    { title: 'VALOR COMERCIAL', dataIndex: 'valor declarado', key: 'valor declarado', width: 150 },
    {
      title: 'Contrapago',
      dataIndex: 'AplicaContrapago',
      key: 'AplicaContrapago',
      width: 100,
      render: (text) => {
        return text === true || text === 'true' || text === 1 || text === '1' ? 'Sí' : 'No';
      }
    },
    {
      title: 'Valor Cotización',
      key: 'cotizacion_valor',
      width: 150,
      render: (text, record, index) => {
        // Crear el mismo ID único que usamos en handleCotizar
        const uniqueId = `${index}_${record['numero documento']?.toString()}`;
        
        // Extraemos la cotización específica usando el ID único
        const cotizacion = cotizacionResults[uniqueId];
        
        // Si no hay cotización, mostramos mensaje
        if (!cotizacion) return 'Sin cotización';
        
        // Si hay error en la cotización, mostramos el error
        if (!cotizacion.exito) return 'Error: ' + cotizacion.mensaje;
        
        // Extraemos los valores numéricos
        const valor = Number(cotizacion.valor || 0);
        const valor_contrapago = Number(cotizacion.valor_contrapago || 0);
        const comision_interna = Number(cotizacion.comision_interna || 0);
        const sobreflete = Number(cotizacion.sobreflete || 0);
        const seguro99 = Number(cotizacion.seguro99 || 0);
        
        // Calculamos el valor total
        const valorTotal = valor + valor_contrapago + comision_interna + sobreflete + seguro99;
        
        // Devolvemos el valor formateado
        return `$${valorTotal.toLocaleString('es-CO')}`;
      }
    },
    // Nueva columna para Valor a Recibir (similar a guiaForm)
    {
      title: 'Valor a recibir',
      key: 'valor_a_recibir',
      width: 150,
      render: (text, record, index) => {
        // Solo aplica para envíos con contrapago
        if (!record.AplicaContrapago) {
          return 'No aplica';
        }
        
        // Obtenemos el valor declarado del registro
        const valorDeclarado = Number(record['valor declarado'] || 0);
        
        // Devolvemos el valor formateado en formato moneda
        return {
          props: { style: { color: '#000', fontWeight: 'normal' } },
          children: `$${valorDeclarado.toLocaleString('es-CO')}`
        };
      }
    },
    // Nueva columna para Costo del envío (similar a guiaForm)
    {
      title: 'Costo del envío',
      key: 'costo_envio',
      width: 150,
      render: (text, record, index) => {
        // Solo aplica para envíos con contrapago
        if (!record.AplicaContrapago) {
          return 'No aplica';
        }
        
        // Crear el mismo ID único que usamos en handleCotizar
        const uniqueId = `${index}_${record['numero documento']?.toString()}`;
        
        // Extraemos la cotización específica usando el ID único
        const cotizacion = cotizacionResults[uniqueId];
        
        // Si no hay cotización o hay error, no podemos calcular
        if (!cotizacion || !cotizacion.exito) return 'Pendiente';
        
        // Extraemos los valores numéricos
        const valor = Number(cotizacion.valor || 0);
        const valor_contrapago = Number(cotizacion.valor_contrapago || 0);
        const comision_interna = Number(cotizacion.comision_interna || 0);
        const sobreflete = Number(cotizacion.sobreflete || 0);
        const seguro99 = Number(cotizacion.seguro99 || 0);
        
        // Calculamos el valor total del envío
        const costoTotal = valor + valor_contrapago + comision_interna + sobreflete + seguro99;
        
        // Devolvemos el valor formateado en rojo con signo negativo (como en guiaForm)
        return {
          props: { style: { color: '#ff4d4f', fontWeight: 'normal' } },
          children: `-$${costoTotal.toLocaleString('es-CO')}`
        };
      }
    },
    // Modificamos el título de "Tu ganancia" para coincidir con guiaForm
    {
      title: 'Tu ganancia',
      key: 'tu_ganancia',
      width: 150,
      render: (text, record, index) => {
        // Solo aplica para envíos con contrapago
        if (!record.AplicaContrapago) {
          return 'No aplica';
        }
        
        // Crear el mismo ID único que usamos en handleCotizar
        const uniqueId = `${index}_${record['numero documento']?.toString()}`;
        
        // Extraemos la cotización específica usando el ID único
        const cotizacion = cotizacionResults[uniqueId];
        
        // Si no hay cotización o hay error, no podemos calcular
        if (!cotizacion || !cotizacion.exito) return 'Pendiente';
        
        // Extraemos los valores numéricos
        const valor = Number(cotizacion.valor || 0);
        const valor_contrapago = Number(cotizacion.valor_contrapago || 0);
        const comision_interna = Number(cotizacion.comision_interna || 0);
        const sobreflete = Number(cotizacion.sobreflete || 0);
        const seguro99 = Number(cotizacion.seguro99 || 0);
        
        // Calculamos el valor total del envío
        const costoTotal = valor + valor_contrapago + comision_interna + sobreflete + seguro99;
        
        // Obtenemos el valor declarado del registro
        const valorDeclarado = Number(record['valor declarado'] || 0);
        
        // Calculamos lo que recibirá el vendedor (valor declarado - costo envío)
        const valorARecibir = valorDeclarado - costoTotal;
        
        // Devolvemos el valor formateado en verde para destacarlo (como en guiaForm)
        return {
          props: { style: { color: '#52c41a', fontWeight: 'bold' } },
          children: `$${valorARecibir.toLocaleString('es-CO')}`
        };
      }
    },
    {
      title: 'Estado',
      key: 'estado',
      width: 220,
      render: (text, record, index) => {
        // Crear el mismo ID único que usamos en handleCotizar
        const uniqueId = `${index}_${record['numero documento']?.toString()}`;
        const docId = record['numero documento'];
        const cotizacion = cotizacionResults[uniqueId];
        const preenvio = preenvioStatus[docId];
        const pdfStatus = pdfGenerationStatus[docId];

        // Caso 1: No hay cotización
        if (!cotizacion) {
          return { 
            props: { style: { color: '#999' } }, 
            children: (
              <div>
                <InfoCircleOutlined style={{ marginRight: 8 }} />
                Pendiente de cotizar
              </div>
            )
          };
        }

        // Caso 2: Error en cotización
        if (cotizacion.exito === false) {
          return {
            props: { style: { color: '#ff4d4f' } },
            children: (
              <Tooltip title={cotizacion.details || cotizacion.mensaje || 'Error en la cotización'}>
                <div style={{ cursor: 'pointer' }}>
                  <WarningOutlined style={{ marginRight: 8 }} />
                  {cotizacion.respuesta || 'Error de cotización'}
                </div>
              </Tooltip>
            )
          };
        }

        // Caso 3: Preenvío en proceso
        if (preenvio === 'processing') {
          return {
            props: { style: { color: '#1890ff' } },
            children: (
              <div>
                <LoadingOutlined style={{ marginRight: 8 }} spin />
                Generando preenvío...
              </div>
            )
          };
        }

        // Caso 4: Error en preenvío
        if (preenvio?.status === 'error') {
          const errorDetails = preenvio.details === preenvio.message ? '' : preenvio.details;
          return {
            props: { style: { color: '#ff4d4f' } },
            children: (
              <Tooltip title={errorDetails}>
                <div style={{ cursor: 'pointer' }}>
                  <WarningOutlined style={{ marginRight: 8 }} />
                  {preenvio.message}
                </div>
              </Tooltip>
            )
          };
        }

        // Caso 5: PDF en proceso
        if (pdfStatus === 'processing') {
          return {
            props: { style: { color: '#1890ff' } },
            children: (
              <div>
                <LoadingOutlined style={{ marginRight: 8 }} spin />
                Generando PDF...
              </div>
            )
          };
        }

        // Caso 6: Error en PDF
        if (pdfStatus === 'error') {
          return {
            props: { style: { color: '#ff4d4f' } },
            children: (
              <div>
                <WarningOutlined style={{ marginRight: 8 }} />
                Error al generar PDF
              </div>
            )
          };
        }

        // Caso 7: PDF generado exitosamente
        if (pdfStatus === 'success') {
          return {
            props: { style: { color: '#52c41a' } },
            children: (
              <div>
                <CheckCircleOutlined style={{ marginRight: 8 }} />
                Guía generada
              </div>
            )
          };
        }

        // Caso 8: Cotización exitosa (estado por defecto)
        return { 
          props: { style: { color: '#52c41a' } }, 
          children: (
            <div>
              <CheckCircleOutlined style={{ marginRight: 8 }} />
              Cotización exitosa
            </div>
          )
        };
      }
    }
  ];

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };



  return (
    <>
      <NavbarMex title={"Envíos Masivo Final"} />

      <div className="masivoFinal-containerMasivos-masivo-guias-99">
        {modalMessage && modalMessage.activo && (
          <Alert
            message={modalMessage.mensaje}
            type="info"
            closable
            style={{ marginBottom: '16px' }}
          />
        )}

        <div className="header-section-masivo-guias-99">
          <h1>Sistema de Envíos Masivos</h1>
        </div>

        <div className="alert-container-masivo-guias-99">
          <div className="alerts-wrapper-masivo-guias-99">
            <Alert
              message={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <InfoCircleOutlined />
                  <span>
                    Tutorial de envíos masivos disponible.{" "}
                    <Button type="link" onClick={showModal} style={{ padding: '4px' }}>
                      Ver video
                    </Button>
                  </span>
                </div>
              }
              type="info"
              showIcon={false}
              style={{ marginBottom: '12px' }}
            />
            <Alert
              message={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <WarningOutlined />
                  <span>
                    <strong>Importante:</strong> Verifica tu saldo disponible antes de generar guías sin contrapago.
                  </span>
                </div>
              }
              type="warning"
              showIcon={false}
            />
          </div>
        </div>

        <div className="controls-section-masivo-guias-99">
          {/* Grupo de archivo */}
          <div className="control-group-masivo-guias-99">
            <div className="file-input-container-masivo-guias-99">
              <button className="button-masivo-guias-99 button-upload-masivo-guias-99">
                <UploadOutlined /> Subir Archivo
              </button>
              <input
                type="file"
                className="file-input-masivo-guias-99"
                onChange={(e) => handleFileUpload({ file: e.target.files[0] })}
                accept=".xlsx,.xls"
              />
            </div>
          </div>

          <div className="control-group-masivo-guias-99">
            <a href={sampleFile} download>
              <button className="button-masivo-guias-99 button-template-masivo-guias-99">
                <UploadOutlined /> Plantilla
              </button>
            </a>
          </div>

          {/* Grupo de transportadora */}
          <div className="control-group-masivo-guias-99">
            <select
              className="select-masivo-guias-99"
              value={selectedTransportadora}
              onChange={(e) => handleTransportadoraChange(e.target.value)}
            >
              <option value="">Transportadora</option>
              {transportadoras.map(transportadora => (
                <option key={transportadora} value={transportadora}>
                  {transportadora.charAt(0).toUpperCase() + transportadora.slice(1)}
                </option>
              ))}
            </select>
          </div>

          {/* Grupo de tipo de envío (solo para interrapidisimo) */}
          {showTipoEnvioSelect && (
            <div className="control-group-masivo-guias-99">
              <select
                className="select-masivo-guias-99"
                value={selectedTipoEnvio}
                onChange={(e) => handleTipoEnvioChange(e.target.value)}
              >
                <option value="">Tipo de envío</option>
                {tipoEnvio.map(tipo => (
                  <option key={tipo} value={tipo}>
                    {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Grupo de tamaño de guía */}
          <div className="control-group-masivo-guias-99">
            <select
              className="select-masivo-guias-99"
              value={selectedTamanoGuia}
              onChange={(e) => setSelectedTamanoGuia(e.target.value)}
            >
              <option value="1">Sticker</option>
              <option value="2">Media Carta</option>
            </select>
          </div>

          {/* Grupo de seguro99 */}
          <div className="control-group-masivo-guias-99">
            <label className="checkbox-container-masivo-guias-99">
              <input
                name="seguro99"
                type="checkbox"
                className="checkbox-input-masivo-guias-99"
                checked={seguro99Enabled}
                onChange={(e) => handleSeguro99Change(e, e.target.checked)}
              />
              <span className="checkbox-custom-masivo-guias-99"></span>
              <span className="checkbox-label-masivo-guias-99">
                Seguro 99
                <Tooltip title={
                  <div style={{ padding: '8px 0' }}>
                    <p style={{ margin: '0 0 8px 0', fontWeight: '500' }}>{"🛡️ Seguro Antidevoluciones"}</p>
                    <p style={{ margin: '0 0 8px 0' }}>{"El valor del seguro será cobrado en caso de generarse una devolución o entrega."}</p>
                  </div>
                }>
                  <InfoCircleOutlined style={{ color:'#4c45b1', cursor: 'help', marginLeft: '4px' }} />
                </Tooltip>
              </span>
            </label>
          </div>

          {/* Grupo de seguro99Plus*/}
          <div className="control-group-masivo-guias-99">
            <label className="checkbox-container-masivo-guias-99">
              <input  
                name="seguro99Plus"
                type="checkbox"
                className="checkbox-input-masivo-guias-99"
                checked={seguro99PlusEnabled}
                onChange={(e) => handleSeguro99Change(e,e.target.checked)}
              />
              <span className="checkbox-custom-masivo-guias-99"></span>
              <span className="checkbox-label-masivo-guias-99">
                Seguro 99 Plus
                <Tooltip title={
                  <div style={{ padding: '8px 0' }}>
                    <p style={{ margin: '0 0 8px 0', fontWeight: '500' }}>{"Seguro Antidevoluciones Plus"}</p>
                    <p style={{ margin: '0 0 8px 0' }}>{"En caso de una devolución, no asumes ningún costo: no pagas el envío de ida, ni el de regreso, ni el valor del seguro. El costo total es cero."}</p>
                  </div>
                }>
                  <InfoCircleOutlined style={{ color:'#4c45b1', cursor: 'help', marginLeft: '4px' }} />
                </Tooltip>
              </span>
            </label>
          </div>
        </div>

        {/* Botones de acción */}
        <div className="action-buttons-masivo-guias-99">
          <Button
            type="primary"
            onClick={handleCotizar}
            disabled={loading || data.length === 0 || selectedTransportadora === ''}
            style={{ backgroundColor: '#4c45b1', borderColor: '#4c45b1', color: 'white' }}
          >
            {loading ? 'Cotizando...' : 'Cotizar'}
          </Button>

          {allCotizacionesDone && (
            <>
              {/* Botón modificado para alternar entre sumar y quitar costo de envío */}
              <Button
                type="primary"
                onClick={handleToggleCostoEnvio}
                disabled={loading || recotizando}
                style={{ 
                  backgroundColor: costoEnvioSumado ? '#f5a623' : '#4a90e2', 
                  borderColor: costoEnvioSumado ? '#f5a623' : '#4a90e2',
                  marginLeft: '10px'
                }}
              >
                {recotizando ? (
                  <>
                    <LoadingOutlined style={{ marginRight: 8 }} spin /> 
                    Recalculando...
                  </>
                ) : costoEnvioSumado ? (
                  'Quitar costo de envío'
                ) : (
                  'Sumar costo de envío'
                )}
              </Button>

              <Button
                type="primary"
                onClick={handlePreenvioAndZip}
                disabled={loading}
                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', marginLeft: '10px' }}
              >
                {loading ? 'Generando...' : 'Generar Guías'}
              </Button>
            </>
          )}
          {loading && <Spin size="small" />}
        </div>

        <div className="table-section-masivo-guias-99">
          <Table
            className="ant-table-masivo-guias-99"
            dataSource={data}
            columns={columns}
            rowKey={(record) => `${record['numero documento']}_${record.nombre}_${Math.random()}`}
            bordered
            size="small"
            pagination={false}
            scroll={{ x: 'max-content', y: '50vh' }}
          />
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '20px'
        }}>
          <ManifiestoGenerator
            buttonText="Generar Manifiesto"
            buttonStyle={{
              backgroundColor: '#217346',
              height: '36px',
              borderRadius: '6px',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        {/* Modal del video */}
        <Modal
          title="Instructivo de recolección"
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          destroyOnClose={true}
          width="100vh"
          style={{ top: 20 }}
          bodyStyle={{ padding: 0 }}
        >
          <div style={{ position: 'relative', paddingBottom: '65%', height: 0, overflow: 'hidden' }}>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/wSDLo4-E2iA?si=G4_4J-Cp2d-20lE3"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            ></iframe>
          </div>
        </Modal>
        <Modal
                open={isVisibleModalWarning}
                centered
                width={480}
                className="seguro99-warning-modal"
                footer={null}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#f5a623",
                    marginBottom: "0",
                  }}
                >
                  <WarningOutlined style={{ fontSize: "20px" }} />
                  <span style={{ fontSize: "16px", fontWeight: "500" }}>
                    Seguro Antidevoluciones desactivado
                  </span>
                </div>
                <div
                  style={{
                    marginTop: "16px",
                    background: "#fff9e6",
                    padding: "16px",
                    borderRadius: "8px",
                    border: "1px solid #ffd666",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      color: "#595959",
                      fontSize: "14px",
                      textAlign: "center",
                      lineHeight: "1.5",
                    }}
                  >
                    🚨 Hola! Desde 99envíos.com queremos contarte algo importante: Hemos
                    notado que tu cuenta ha superado el porcentaje de devoluciones
                    aceptable para mantener activo el seguro antidevolución 🛡 Para
                    ayudarte a mejorar ese indicador y recuperar el beneficio, te
                    invitamos a una capacitación personalizada 📚 👉 Ingresa aquí para
                    agendarla:{" "}
                    <a href="https://99envios.app/dashboard99?seguro99=true">
                      {/* https://99envios.com/capacitacion/ */}
                      Click aquí
                    </a>{" "}
                    <br />
                    Con gute apoyamos para que puedas seguir enviando con todas las
                    ventajas que te ofrece nuestra plataforma 
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#f5a623",
                        borderColor: "#f5a623",
                        borderRadius: "4px",
                        height: "32px",
                        fontWeight: "500",
                      }}
                      type="primary"
                      onClick={() => {
                        setIsVisibleModalWarning(false);
                        setSeguro99Enabled(false);
                      }}
                    >
                      Ententido
                    </Button>
                  </div>
                </div>
              </Modal>
      </div>
    </>
  );
};

// Asegura que cada cotización tenga un ID único en React para forzar el re-renderizado
function forceUniqueValues(cotizaciones) {
  const resultado = {};
  Object.entries(cotizaciones).forEach(([docId, cotizacion]) => {
    resultado[docId] = {
      ...cotizacion,
      _id: `${docId}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: Date.now() + Math.random(),
      valor: Number(cotizacion.valor || 0),
      valor_contrapago: Number(cotizacion.valor_contrapago || 0),
      comision_interna: Number(cotizacion.comision_interna || 0),
      sobreflete: Number(cotizacion.sobreflete || 0),
      seguro99: Number(cotizacion.seguro99 || 0),
    };
  });
  return resultado;
}

export default ExcelUploader;